import { CSSProperties } from "react";

import { LicenseAssignationModalStyles } from "./LicenseAssignationModal";

type AssignStatus = "idle" | "loading" | "success" | "error";

export const AssignLicenseToUserModalStyles = {
  container: {
    ...LicenseAssignationModalStyles.modalContainer,
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
  },

  assigningToLabel: { mb: 1 },

  chipsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    mb: 3,
  },

  pairsPaper: {
    mb: 3,
    overflow: "hidden",
    flexShrink: 1,
  },

  pairsScrollBox: {
    maxHeight: 320,
    overflowY: "auto",
  },

  pairRowBox: (hasActiveState: boolean) => ({
    px: 2,
    pt: 1.5,
    pb: hasActiveState ? 1 : 1.5,
  }),

  mainRow: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },

  licenseInfoBox: { flex: 1, minWidth: 0 },

  licenceIdSuffix: {
    fontWeight: 400,
    fontSize: "0.7em",
  } as CSSProperties,

  expiringSoonIcon: {
    fontSize: 14,
    color: "warning.main",
  },

  arrowIcon: (isSuccess: boolean) => ({
    flexShrink: 0,
    color: isSuccess ? "success.main" : "text.secondary",
    transition: "color 0.3s",
  }),

  userStatusBox: {
    flex: 1,
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 0.75,
  },

  successIcon: { color: "success.main", fontSize: 18 },

  errorIcon: { color: "warning.dark", fontSize: 18 },

  progressBarBox: { mt: 1 },

  progressBar: (status: AssignStatus, tickMs: number) => ({
    height: 4,
    borderRadius: 2,
    backgroundColor: status === "error" ? "warning.light" : undefined,
    "& .MuiLinearProgress-bar": {
      backgroundColor:
        status === "success"
          ? "success.main"
          : status === "error"
            ? "warning.dark"
            : undefined,
      transition:
        status === "success"
          ? "transform 0.4s ease"
          : `transform ${tickMs}ms linear`,
    },
  }),

  noLicenseBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  noLicenseIcon: { color: "warning.dark", fontSize: 18 },
};
